import React from "react";
import { ClearFloat } from "components/common";
import AggregationConditionExpression from "../AggregationConditionExpression";
const BooleanExpression = ({ expression, level, onChildChange, validation = {}, ...props }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  AggregationConditionExpression,
  {
    ...props,
    expression: expression.left,
    validation: validation.left,
    parent: expression,
    onChange: onChildChange("left"),
    level: level + 1
  }
), /* @__PURE__ */ React.createElement(ClearFloat, null), /* @__PURE__ */ React.createElement(
  AggregationConditionExpression,
  {
    ...props,
    expression: expression.right,
    validation: validation.right,
    parent: expression,
    onChange: onChildChange("right"),
    level: level + 1,
    renderLabel: false
  }
));
export default BooleanExpression;
